import { ReactNode, useState } from 'react';
import { FaRegCreditCard } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import { RiMoreFill, RiShieldStarFill } from "react-icons/ri";
import { SiApplepay } from "react-icons/si";
import { useTranslationsByLabel } from '~/api/useTranslationsByLabel';
import TranslationsLoadingUI from '~/components/translations/admin/TranslationsLoadingUI';
import { useCommonAppContext } from '~/shared/contexts/CommonAppContext';
import { getLcn } from '~/utils/labeled-classnames';
import { Amazon, CashApp, Klarna, LinkIcon } from './svg';
import { tiers } from './tiers';
//import { tiersTestMode as tiers } from './tiers';

import { SlArrowDown, SlArrowUp } from 'react-icons/sl';
import Tier from './Tier';

type PaymentOption = [ReactNode, string]

export const PremiumIcon = RiShieldStarFill

const paymentOpts: PaymentOption[] = [
  [
    <FaRegCreditCard size={20} />,
    'Card'
  ],
  [
    <SiApplepay size={25} />,
    'Apple Pay',
  ],
  [
    <FcGoogle size={20} />,
    'Google Pay'
  ],
  [
    <Klarna />,
    'Klarna'
  ],
  [
    <LinkIcon />,
    'Link'
  ],
  [
    <CashApp />,
    'Cash App',
  ],
  [
    <Amazon />,
    'Amazon Pay'
  ],
  [
    <RiMoreFill />,
    ''
  ],
]


export default function StripePremiumDialogContent({ children }: { children?: ReactNode }) {
  const { locale } = useCommonAppContext()
  const [showMore, setShowMore] = useState(true)

  const lcn = getLcn({
    StripePremiumDialogContent: 'flex flex-col gap-10',
    moreButton: [
      'flex gap-2',
      'bg-white/5 hover:bg-white/10 p-2 px-3 rounded-full flex items-center justify-center mx-auto mt-2'
    ]
  });

  const { t, ts, isTranslationsSuccess, response } = useTranslationsByLabel({
    site_id: 2,
    locale,
    labels: [
      'share_box.',
      'get_premium.',
    ],
  })

  if (!isTranslationsSuccess) {
    return <TranslationsLoadingUI response={response} />
  }
  return (
    <>
      <div className={lcn.StripePremiumDialogContent}>
        <div className='flex flex-col gap-3'>
          <div className='text-2xl flex gap-2 font-semibold'>
            <div> <PremiumIcon className='mt-1' /> </div>
            {t('get_premium.premium_access_pass', { html: true })}
          </div>

          {children ?
            children
            :
            t('get_premium.description')
          }
        </div>

        <div>
          <div className='grid grid-cols-1 sm:grid-cols-2  gap-4'>
            {tiers.map((tierData, i) => {
              if (!showMore && i > 3) return null;

              return (
                <Tier key={tierData.pricing_id} tierData={tierData} t={t} />
              )
            })}
          </div>

          {/* <button className={lcn.moreButton} onClick={() => setShowMore(!showMore)}>
            <span>{showMore ? <SlArrowUp /> : <SlArrowDown />}</span>
            <span className='text-sm'>
              {t('get_premium.more_access_passes', { html: true })}
            </span>
          </button> */}
        </div>

        <div className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 p-4'>
          {paymentOpts.map(([icon, text]) => (
            <div className='flex gap-2 items-center justify-start  ' key={text}>
              <div>{icon}</div>
              <div className='text-xs opacity-70'>{text}</div>
            </div>
          ))}
        </div>
      </div >
    </>
  );
}; 